import { render, staticRenderFns } from "./PurchasedCourse.vue?vue&type=template&id=d4153416&scoped=true&"
import script from "./PurchasedCourse.vue?vue&type=script&lang=js&"
export * from "./PurchasedCourse.vue?vue&type=script&lang=js&"
import style0 from "./PurchasedCourse.vue?vue&type=style&index=0&id=d4153416&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4153416",
  null
  
)

export default component.exports